import { postApi } from '../../utils/api'

export function createAddress(data) {
  return postApi({
    data,
    endpoint: `/api/address/`,
  })
}
